import * as tslib_1 from "tslib";
import { jsonArrayMember, jsonMember, jsonObject } from "typedjson";
import { PitFilteringAttribute } from "./pit-filtering-attribute";
import { PitFilterTreeNodeType } from "./pit-filter-tree-node-type";
/**
 * Узел дерева филтров.
 * Идея такова:
 *
 * 1. У нас есть несколько типов сущностей, которые нужно отображать в виде реестра (таблицы).
 *    Классический подход заключается в том, что "Реестр" является отдельным документом, к которому на уровне БД
 *    привязаны, например, задачи, мероприятия, планы и тд. Таким образом узлами дерва являются документы-реестры.
 *    При выборе узла в дереве по его документу подтягиваются данные в таблицу.
 *
 * 2. Такак-как такая завяка в БД мягко говоря гемор, то можно попробовать реализовать более универсальный подход.
 *    Пусть дерево будет не дервом документов, дервом объектов-фильров. То есть ноды "фильтрующего" дерева это:
 *
 *    2.1. Группируюшие папки
 *    2.2. Объекты-фильтры, содержащие некие метаданные о том как фильтрануть множество сущностей определнного типа,
 *         чтобы получить нужное подмножество (реестр).
 *
 * 3. Данный класс по сути декларирует лишь то что, по-сути, необходимо для отрисовки дерева.
 *    Как включить сюда метаданные для фильтрации конкртеного типа сущностей надо подумать.
 */
let PitFilterTreeNode = class PitFilterTreeNode {
    getItemId() {
        return this._id;
    }
    getParentItemId() {
        return this._parentId;
    }
    setParentItemId(value) {
        this._parentId = value;
    }
    getItemType() {
        return this._typeObj.id === 1 ? 'FOLDER' : 'FILTER';
    }
    setItemType(value) {
        //this._type = value;
    }
    getItemOrd() {
        return this._ord;
    }
    getItemTitle() {
        return this._title;
    }
    getItemIdent() {
        return this._ident;
    }
    getItemIcon() {
        return "";
    }
    getItemDescription() {
        return this._description;
    }
    getItemSearchString() {
        return "";
    }
    canExecuteToolbarAction(action) {
        return true;
    }
    get id() {
        return this._id;
    }
    set id(value) {
        this._id = value;
    }
    get parentId() {
        return this._parentId;
    }
    set parentId(value) {
        this._parentId = value;
    }
    get ord() {
        return this._ord;
    }
    set ord(value) {
        this._ord = value;
    }
    get ident() {
        return this._ident;
    }
    set ident(value) {
        this._ident = value;
    }
    get title() {
        return this._title;
    }
    set title(value) {
        this._title = value;
    }
    get type() {
        return /*this._type*/ this._typeObj.id === 1 ? 'FOLDER' : 'FILTER';
    }
    set type(value) {
        //this._type = value;
    }
    get description() {
        return this._description;
    }
    set description(value) {
        this._description = value;
    }
    get attributes() {
        return this._attributes;
    }
    set attributes(value) {
        this._attributes = value;
    }
    get treeId() {
        return this._treeId;
    }
    set treeId(value) {
        this._treeId = value;
    }
    get typeObj() {
        return this._typeObj;
    }
    set typeObj(value) {
        this._typeObj = value;
    }
    get sqlFilter() {
        return this._sqlFilter;
    }
    set sqlFilter(value) {
        this._sqlFilter = value;
    }
};
tslib_1.__decorate([
    jsonMember({ name: "id", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitFilterTreeNode.prototype, "_id", void 0);
tslib_1.__decorate([
    jsonMember({ name: "parentId", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitFilterTreeNode.prototype, "_parentId", void 0);
tslib_1.__decorate([
    jsonMember({ name: "treeId", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitFilterTreeNode.prototype, "_treeId", void 0);
tslib_1.__decorate([
    jsonMember({ name: "ord", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitFilterTreeNode.prototype, "_ord", void 0);
tslib_1.__decorate([
    jsonMember({ name: "ident", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], PitFilterTreeNode.prototype, "_ident", void 0);
tslib_1.__decorate([
    jsonMember({ name: "name", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], PitFilterTreeNode.prototype, "_title", void 0);
tslib_1.__decorate([
    jsonMember({ name: "type", constructor: PitFilterTreeNodeType, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", PitFilterTreeNodeType)
], PitFilterTreeNode.prototype, "_typeObj", void 0);
tslib_1.__decorate([
    jsonMember({ name: "description", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], PitFilterTreeNode.prototype, "_description", void 0);
tslib_1.__decorate([
    jsonMember({ name: "sqlFilter", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], PitFilterTreeNode.prototype, "_sqlFilter", void 0);
tslib_1.__decorate([
    jsonArrayMember(PitFilteringAttribute, { name: "attributes", emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Array)
], PitFilterTreeNode.prototype, "_attributes", void 0);
PitFilterTreeNode = tslib_1.__decorate([
    jsonObject
], PitFilterTreeNode);
export { PitFilterTreeNode };
